import { render, staticRenderFns } from "./CrmExport.vue?vue&type=template&id=1d4a9c5c&scoped=true"
import script from "./CrmExport.vue?vue&type=script&lang=js"
export * from "./CrmExport.vue?vue&type=script&lang=js"
import style0 from "./CrmExport.vue?vue&type=style&index=0&id=1d4a9c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a9c5c",
  null
  
)

export default component.exports